var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus-card"
  }, [_c('img', {
    staticClass: "bonus-card__background-img",
    attrs: {
      "src": require("./asset/bonus-card-bcg.png"),
      "srcset": require("./asset/bonus-card-bcg.png") + " 1x, " + require("./asset/bonus-card-bcg@2x.png") + " 2x",
      "alt": "banner"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bonus-card__title b"
  }, [_vm._v("Покупайте за бонусы!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "bonus-card__subtitle b"
  }, [_vm._v("Как копить бонусы?")]), _vm._v(" "), _c('p', {
    staticClass: "bonus-card__description lh-18 grey-text"
  }, [_vm._v("\n    Зарегистрируйтесь на сайте, чтобы начать копить бонусы, а затем обменивать\n    их на любимые товары!\n  ")]), _vm._v(" "), _c('GGLink', {
    staticClass: "bonus-card__button cc-link cc-link_wu",
    attrs: {
      "to": "/bonus/"
    }
  }, [_c('button', {
    staticClass: "bonus-card__button-el"
  }, [_vm._v("Подробнее о бонусах")])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-25"
  }, [_c('div', {
    staticClass: "bonus-card__row mb-10"
  }, [_c('div', {
    staticClass: "bonus-card__bonus mr-6"
  }, [_vm._v("1")]), _vm._v("\n      =\n      "), _c('div', {
    staticClass: "bonus-card__badge ml-6"
  }, [_vm._v("1₽")])]), _vm._v(" "), _c('p', {
    staticClass: "fz-14 lh-18 grey-text"
  }, [_vm._v("\n      Каждый бонус равен"), _c('br'), _vm._v("\n      одному рублю\n    ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-45"
  }, [_c('div', {
    staticClass: "bonus-card__row mb-10"
  }, [_c('div', {
    staticClass: "bonus-card__bonus mr-6"
  }), _vm._v("\n      =\n      "), _c('div', {
    staticClass: "bonus-card__badge ml-6"
  }, [_vm._v("100%")])]), _vm._v(" "), _c('p', {
    staticClass: "fz-14 lh-18 grey-text"
  }, [_vm._v("\n      Оплачивайте полную"), _c('br'), _vm._v("\n      стоимость покупки\n    ")])]);
}]

export { render, staticRenderFns }